import useLayoutEffect from '@react-hook/passive-layout-effect';
import useLatest from '@react-hook/latest';

function useEvent(target, type, listener, cleanup = noop) {
  const storedListener = useLatest(listener);
  const storedCleanup = useLatest(cleanup);

  function _ref(...args) {
    storedListener.current.apply(this, args);
  }

  useLayoutEffect(() => {
    const targetEl = target && 'current' in target ? target.current : target;
    if (!targetEl) return;
    const listener = _ref;
    targetEl.addEventListener(type, listener);
    const cleanup = storedCleanup.current;
    return () => {
      targetEl.removeEventListener(type, listener);
      cleanup();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, type]);
} // eslint-disable-next-line @typescript-eslint/no-empty-function


function noop() {}

export default useEvent;